module.exports = __webpack_public_path__ + "img/slide-about.d50ed492.jpg";